import styled from 'styled-components';
import { removeScrollbar } from '@/styles/helpers';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const FiltersContainer = styled.div`
  ${removeScrollbar()}

  display: flex;
  width: 100%;
  gap: 5px;
  padding: 10px 15px;
  overflow-x: auto;
`;

export const SortContainer = styled.div`
  padding: 8px 15px 10px;
`;
